import {
  addPaymentMethod,
  getPaymentMethods,
  updatePaymentMethod,
  removePaymentMethod,
} from '../../api/admin';
import invalidationManager from './InvalidationManager';
import { PaymentMethod } from '../../model/PaymentMethod';

const { hook: usePaymentMethods } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'paymentMethods'],
  fetchFunction: async (companyId: string): Promise<PaymentMethod[]> => {
    return getPaymentMethods(companyId);
  },
});

const useCreatePaymentMethodMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    paymentMethod: Partial<PaymentMethod> & {
      startDate?: string;
      endDate?: string;
      config?: Record<string, unknown>;
    },
  ) => {
    await addPaymentMethod(companyId, paymentMethod);
    await invalidationManager.invalidate(['company', companyId, 'paymentMethods']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

const useUpdatePaymentMethodMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    paymentMethodId: string,
    paymentMethod: Partial<PaymentMethod>,
  ) => {
    await updatePaymentMethod(companyId, paymentMethodId, paymentMethod);
    await invalidationManager.invalidate(['company', companyId, 'paymentMethods']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

const useDeletePaymentMethodMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, paymentMethodId: string) => {
    await removePaymentMethod(companyId, paymentMethodId);
    await invalidationManager.invalidate(['company', companyId, 'paymentMethods']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

export {
  usePaymentMethods,
  useCreatePaymentMethodMutation,
  useUpdatePaymentMethodMutation,
  useDeletePaymentMethodMutation,
};
